document.addEventListener('DOMContentLoaded', function () {

  /* ==========================
     Thumbnail Image Change
  ========================== */

  const mainImage = document.querySelector('[id^="ProductMainImage"]');

  const thumbs = document.querySelectorAll('.bsp-thumb img');

  thumbs.forEach(function (thumb) {

    thumb.addEventListener('click', function () {

      if (mainImage) {
        mainImage.src = this.dataset.full;
      }

      thumbs.forEach(function (img) {
        img.parentElement.classList.remove('active');
      });

      this.parentElement.classList.add('active');

    });

  });


  /* ==========================
     Quantity Plus / Minus
  ========================== */

  const qtyInput = document.querySelector('.qty-box input');

  const plusBtn = document.querySelector('.qty-plus');

  const minusBtn = document.querySelector('.qty-minus');

  if (plusBtn && qtyInput) {

    plusBtn.addEventListener('click', function () {

      qtyInput.value = parseInt(qtyInput.value) + 1;

    });

  }

  if (minusBtn && qtyInput) {

    minusBtn.addEventListener('click', function () {

      let qty = parseInt(qtyInput.value);

      if (qty > 1) {
        qtyInput.value = qty - 1;
      }

    });

  }


  /* ==========================
     Active Thumbnail
  ========================== */

  if (thumbs.length > 0) {
    thumbs[0].parentElement.classList.add('active');
  }

});